export default __webpack_public_path__ + "static/media/iso_14001.fef6ce52.png";